import * as api from '../../utils/bookboost/api';
import { conversyEvents } from '../../utils/bookboost/events';

export const PM_FIRED = 'PM_FIRED';
export const PM_CLICKED = 'PM_CLICKED';
export const PM_COUPON_CLICKED = 'PM_COUPON_CLICKED';
export const CONVERSATION_OPENED = 'CONVERSATION_OPENED';
export const CONVERSATION_CLOSED = 'CONVERSATION_CLOSED';

export const trackEvent = (type, data) => (dispatch) => {
    conversyEvents.trigger(type, data);
    const event = {
        type,
        data,
        timestamp: Date.now()
    };
    return dispatch(api.trackEvent(event));
};

const pmEvent = (type, id) => trackEvent(type, { id });

export const pmFired = (id) => pmEvent(PM_FIRED, id);
export const pmClicked = (id) => pmEvent(PM_CLICKED, id);
export const pmCouponClicked = (id) => pmEvent(PM_COUPON_CLICKED, id);

export const conversationOpened = () => trackEvent(CONVERSATION_OPENED);
export const conversationClosed = () => trackEvent(CONVERSATION_CLOSED);
